var initialState = {
  environment: undefined,
  domainName: undefined
};
export default initialState;